<template>
  <div class="col-md-12 clients_list">
    <div class="header">
      <div class="form">
        <fg-input
            v-model="searched_client"
            type="text"
            class="search_user"
            placeholder="Name, Ur_name, City or INN"
        />

        <div class="filter checkbox">
          <div class="info">
            {{this.translate('client.active_clients')}}
          </div>
          <label class="switch" @click.prevent="active_clients = !active_clients">
            <input type="checkbox" v-model="active_clients">
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <span
          class="mdi mdi-plus-circle-outline btn btn-success btn-fill"
          @click.prevent="show_info(null)"
      >
        <b>{{ translate('client.to_add') }}</b>
      </span>
    </div>

    <div class="row response_table">
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th scope="col">
              {{ translate('client.main_info.name') }}
            </th>
            <th scope="col">
              {{ translate('client.main_info.descr') }}
            </th>
            <th scope="col">
              {{ translate('client.main_info.city') }}
            </th>
            <th scope="col">
              {{ translate('client.main_info.inn') }}
            </th>
            <th scope="col">
              {{ translate('client.main_info.create') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(client,key) in clients_list"
            :key="key"
            class="client"
            @click="show_info(client.id)"
          >
            <td :data-label="translate('client.main_info.name')">
              {{ client.name }}
            </td>
            <td :data-label="translate('client.main_info.descr')">
              {{ client.descr }}
            </td>
            <td :data-label="translate('client.main_info.descr')">
              {{ client.city }}
            </td>
            <td :data-label="translate('client.main_info.inn')">
              {{ client.inn }}
            </td>
            <td :data-label="translate('client.main_info.create')">
              {{ get_date(client.ts_create) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ClientsModal from './Clients/ClientsModal'

export default {
  name: 'Clients',
  components: {
  },
  data () {
    return {
      clients: {},
      searched_client: '',
      active_clients: true,
      check_link: true
    }
  },
  created () {
    this.get_clients()
  },

  activated () {
    this.get_clients()
  },

  destroyed() {
    this.$modal.hide('client_profile_modal')
  },

  computed:{
    clients_list() {
      if (this.active_clients || this.searched_client !== '') {
        let list_actived = []
        let list_searched = []
        for (let client in this.clients) {
          if (this.active_clients){
            if (this.clients[client].active === 1) {
              list_actived.push(this.clients[client])
            }
          }
          if (this.searched_client !== ''){
            if (this.clients[client].name.toLowerCase().indexOf(this.searched_client.toLowerCase()) > -1 || //Проверка имени в нижнем регистре
                this.clients[client].ur_name.toLowerCase().indexOf(this.searched_client.toLowerCase()) > -1 || //Проверка логина в нижнем регистре
                this.clients[client].city.toLowerCase().indexOf(this.searched_client.toLowerCase()) > -1 ||  //Проверка почты в нижнем регистре
                this.clients[client].inn.toLowerCase().indexOf(this.searched_client.toLowerCase()) > -1 //Проверка Телефона в нижнем регистре
            ) {
              list_searched.push(this.clients[client])
            }
          }
        }
        let final_list = []
        if (this.active_clients && this.searched_client !== '') {
          final_list = list_actived.filter(x => list_searched.includes(x));
        }else{
          final_list = list_actived.length > 0 ? list_actived : list_searched
        }
        final_list = [...new Set(final_list)]
        return final_list
      }
      return this.clients
    }
  },

  methods: {
    close_modal () {
      if (!this.check) {
        history.pushState(null, null, this.window_info)
      }else{
        window.location.href = window.location.href.replace('/' + this.$route.params.user_id, '')
      }
    },
    check_client(){
      if (this.$route.params.client_id){
        for (let index in this.clients) {
          if (+this.clients[index].id === +this.$route.params.client_id || this.clients[index].name === this.$route.params.client_id) {
            this.show_profile(this.clients[index].id)
          }
        }
      }
    },
    show_profile(val){
      if (this.check_link){
        this.check_link = false
        this.show_info(val)
      }
    },
    show_info(client_id) {
      let t = this.$createElement(ClientsModal, {
        props: {
          client_id
        },
        on: {
          close: () => {
            this.$modal.hide('client_profile_modal')
            this.check_link = true
          },
          update: () => { this.get_clients() }
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 800,
        width: 800,
        adaptive: true,
        clickToClose: true,
        name: 'client_profile_modal'
      })
    },
    get_clients(){
      this.$http.v1.getClients((response) => {
        this.clients = response.data

        this.check_client()
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  .header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .form{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 80%;

      .search_user{
        margin-bottom: 0;
        width: 100%;
      }
      .btn{
        width: 30%;
      }
    }
  }
  .clients_list{
    height: 100%;
    .client{
      cursor: pointer;
      &:hover{
        background-color: #eee;
      }
    }
  }

  @media (max-width: 500px){
    .header{
      .form{
        width: 100%;
        .filter{
          min-width: max-content;
          margin: 0 10px;
        }
      }
      .btn{
        b{
          display: none;
        }
        width: 20%;
        min-width: inherit;
      }
      .search_user{
        width: 80%;
      }
    }
  }
</style>
